var CurrentUser = require("lib/account/CurrentUser");
var Modal = require("components/utility/AltModal");
var HouseInteriorRoom = require("components/games/HouseInteriorRoom");
var DressingRoom = require("components/games/DressingRoom")
var TrophyRoom = require("components/games/TrophyRoom");
var Glyphicon = require("components/utility/icons/Glyphicon");

const LEFT = "left"
const RIGHT = "right"
const DRESSING = "dressing"
const TROPHY = "trophy"
const HOUSE = "house"

require("games/house_modal.scss");

class HouseModal extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		if (props.activeRoom && props.activeRoom == TROPHY) {
			var currentRoom = HouseModal.TROPHY_ROOM;
		} else if (props.activeRoom && props.activeRoom == HOUSE) {
			var currentRoom = HouseModal.HOUSE_INTERIOR_ROOM;
		} else if (props.activeRoom && props.activeRoom == DRESSING) {
			var currentRoom = HouseModal.DRESSING_ROOM
		} else {
			var currentRoom = HouseModal.HOUSE_INTERIOR_ROOM;
		}

		this.state = {
			currentRoom

		};
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevProps.activeRoom != this.props.activeRoom) {
			if (this.props.activeRoom == TROPHY) {
				var currentRoom = HouseModal.TROPHY_ROOM;
			} else if (this.props.activeRoom == DRESSING) {
				var currentRoom = HouseModal.DRESSING_ROOM
			} else {
				var currentRoom = HouseModal.HOUSE_INTERIOR_ROOM;
			}
			this.setState({ currentRoom });
		}
	}

	show() {
		this.refs.modal.show();
	}

	switchRooms(direction) {
		if (this.state.currentRoom == HouseModal.TROPHY_ROOM && direction == RIGHT) {
			var newRoom = this.props.ownsHouse ? HouseModal.HOUSE_INTERIOR_ROOM : HouseModal.DRESSING_ROOM
		} else if (this.state.currentRoom == HouseModal.DRESSING_ROOM && direction == LEFT) {
			var newRoom = this.props.ownsHouse? HouseModal.HOUSE_INTERIOR_ROOM : HouseModal.TROPHY_ROOM
		} else if (this.state.currentRoom == HouseModal.HOUSE_INTERIOR_ROOM && direction == RIGHT) {
			var newRoom = HouseModal.DRESSING_ROOM
		} else {
			var newRoom = HouseModal.TROPHY_ROOM
		}
		this.setState({ currentRoom: newRoom });
	}


	updateFurnitures(newFurnitures) {
		if (this.props.updateFurnitures == undefined) {
			this.setState({ allFurnitures: newFurnitures });
		} else {
			this.props.updateFurnitures(newFurnitures);
		}
	}

	
	fetchFurnitures() {
		CurrentUser.api().getPerks(
			{ furniture_only: true },
			$wr.apiHandler(response => {
				this.setState({ allFurnitures: response.perks });
			}),
		);
	}
	getAllFurnitures() {
		if (this.props.allFurnitures == undefined) {
			return this.state.allFurnitures;
		} else {
			return this.props.allFurnitures;
		}
	}

	renderSwitchRoomButtons() {
		if (this.state.currentRoom == HouseModal.DRESSING_ROOM) {
			var roomLabel = this.props.ownsHouse ? "Main Room" : "Trophy Room"
			var switchRoomButtonLeft = (
				<button
					className={"btn btn-link switchRoomLink switchLeft"}
					onClick={() => this.switchRooms(LEFT)}
				>
					<Glyphicon icon={"chevron-left"} dataTip={roomLabel} />
				</button>
			);
		}

		if (this.state.currentRoom == HouseModal.TROPHY_ROOM) {
			var roomLabel = this.props.ownsHouse ? "Main Room" : "Closet"
			var switchRoomButtonRight = (
				<button
					className={"btn btn-link switchRoomLink switchRight"}
					onClick={() => this.switchRooms(RIGHT)}
				>
					<Glyphicon icon={"chevron-right"} dataTip="Main Room" />
				</button>
			);                
		}

		if (this.props.ownsHouse) {
			if (this.state.currentRoom == HouseModal.HOUSE_INTERIOR_ROOM) {
				var switchRoomButtonLeft = (
					<button
						className={"btn btn-link switchRoomLink switchLeft"}
						onClick={() => this.switchRooms(LEFT)}
					>
						<Glyphicon icon={"chevron-left"} dataTip="Trophy Room" />
					</button>
				);
	
				var switchRoomButtonRight = (
					<button
						className={"btn btn-link switchRoomLink switchRight"}
						onClick={() => this.switchRooms(RIGHT)}
					>
						<Glyphicon icon={"chevron-right"} dataTip="Closet" />
					</button>
				);
			}
		}

		return (
			<div>
			{switchRoomButtonLeft}
			{switchRoomButtonRight}
			</div>
		)
			
	}

	render() {
		if (this.state.currentRoom == HouseModal.TROPHY_ROOM) {
			var trophyStyle = {};
			var interiorStyle = { display: "none" };
			var dressingStyle = { display: "none" };
			if (CurrentUser.isAdmin() || this.props.currentStudent) {
				var title = this.props.student.first_name + "'s Trophy Room";
			} else {
				var title = "Trophy Room";
			}
		} else if (this.state.currentRoom == HouseModal.DRESSING_ROOM) {
			var trophyStyle = { display: "none" };
			var interiorStyle = { display: "none" };
			var dressingStyle = {};
			if (CurrentUser.isAdmin() || this.props.currentStudent) {
				var title = this.props.student.first_name + "'s Closet!";
			} else {
				var title = "Closet";
			}
		} else {
			var trophyStyle = { display: "none" };
			var interiorStyle = {};
			var dressingStyle = { display: "none" }
			if (CurrentUser.isAdmin() || this.props.currentStudent) {
				var title = "Welcome to " + this.props.student.first_name + "'s House!";
			} else {
				var title = "Welcome Home!";
			}
		}

		var trophyBody = <TrophyRoom student = {this.props.student} />;

		var dressingBody = <DressingRoom student = {this.props.student} />;

		if (this.props.currentStudent) {
			var interiorBody = (
				<HouseInteriorRoom
					student={this.props.student}
					currentStudent={this.props.currentStudent}
					previewItemName={this.props.previewItemName}
					previewItemType={this.props.previewItemType}
					previewItemTitle={this.props.previewItemTitle}
					ref="houseInteriorRoom"
				/>
			);
		} else {
			if (CurrentUser.hasID(this.props.student.id)) {
				var allFurnitures = this.getAllFurnitures();
				var interiorBody = (
					<HouseInteriorRoom
						student={this.props.student}
						ref="houseInteriorRoom"
						activeRoom={this.props.activeRoom}
						allFurnitures={allFurnitures}
						previewItemName={this.props.previewItemName}
						previewItemType={this.props.previewItemType}
						previewItemTitle={this.props.previewItemTitle}
					/>
				);
			} else {
				var interiorBody = (
					<HouseInteriorRoom
						student={this.props.student}
						ref="houseInteriorRoom"
						activeRoom={this.props.activeRoom}
						previewItemName={this.props.previewItemName}
						previewItemType={this.props.previewItemType}
						previewItemTitle={this.props.previewItemTitle}

					/>
				);
			}
		}

		return (
			<Modal className="houseModal" ref="modal" headerText={title} onShow={this.onModalShow}>
				<div style={trophyStyle}>{trophyBody}</div>
				<div style={interiorStyle}>{interiorBody}</div>
				<div style={dressingStyle}>{dressingBody}</div>
				{this.renderSwitchRoomButtons()}

			</Modal>
		);
	}
	// render() {
	// 	if (this.state.currentRoom == HouseModal.TROPHY_ROOM) {
	// 		if (CurrentUser.isAdmin() || this.props.currentStudent) {
	// 			var title = this.props.student.first_name + "'s Trophy Room"
	// 		} else {
	// 			var title = "Trophy Room";
	// 		}
	// 		var modalBody = (
	// 			<TrophyRoom studentID={ this.props.student.id } />
	// 		);
	// 		var switchButtonClass = "switchRight";
	// 		var glyphiconType = "chevron-right";

	// 	} else {
	// 		if (CurrentUser.isAdmin() || this.props.currentStudent) {
	// 			var title = "Welcome to " + this.props.student.first_name + "'s House!"
	// 		} else {
	// 			var title = "Welcome Home!"
	// 		}
	// 		if (this.props.currentStudent) {
	// 			var modalBody = <HouseInteriorRoom student={ this.props.student }
	// 				currentStudent={ this.props.currentStudent } ref="houseInteriorRoom" />;
	// 		} else {
	// 			var modalBody = <HouseInteriorRoom student={ this.props.student }
	// 				ref="houseInteriorRoom" />;
	// 		}
	// 		var switchButtonClass = "switchLeft";
	// 		var glyphiconType = "chevron-left";
	// 	}

	// 	if (!this.props.trophyRoomOnly) {
	// 		var switchRoomButton = (
	// 			<button className={ "btn btn-link switchRoomLink " + switchButtonClass } onClick={ this.switchRooms }>
	// 				<Glyphicon icon={ glyphiconType } />
	// 			</button>
	// 		);
	// 	}

	// 	return (
	// 		<Modal className="houseModal" ref="modal" headerText={ title } onShow={ this.onModalShow }>
	// 			{ modalBody }
	// 			{ switchRoomButton }
	// 		</Modal>
	// 	)
	// }

	onModalShow() {
		Mycroft.newEvent({
			category: "Owl-Houses",
			action: "opened-house-modal",
			label: this.state.currentRoom,
		});
		this.forceUpdate();
	}

	componentDidMount() {
		if (CurrentUser.hasID(this.props.student.id) && this.props.allFurnitures == undefined) {
			if (this.state.allFurnitures == undefined) {
				this.fetchFurnitures();
			}
		}
	}
	
}

HouseModal.TROPHY_ROOM = "TrophyRoom";
HouseModal.HOUSE_INTERIOR_ROOM = "HouseInteriorRoom";
HouseModal.DRESSING_ROOM = "DressingRoom"

HouseModal.propTypes = StrictPropTypes({
	// Data on the student
	student: PropTypes.object.isRequired,

	// Data on a visiting student
	currentStudent: PropTypes.object,

	// For disabling toggling to rooms other than the trophy room
	activeRoom: PropTypes.string,
	allFurnitures: PropTypes.array,
	updateFurnitures: PropTypes.func,

	//for previewing a furniture item
	previewItemName: PropTypes.string,
	previewItemType: PropTypes.string,
	previewItemTitle: PropTypes.string
});

module.exports = HouseModal;



// WEBPACK FOOTER //
// ./modules/components/games/HouseModal.js